



























import { Vue, Prop, Component } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';
import FormatService from 'services/FormatService';
import { Format, FormatType } from '@models';

@Component
export default class FormatBannerSelector extends Vue {
  name = 'format-banner-selector';

  @Prop(String) id!: string;
  @Prop(Function) onError: any;

  @Prop({ type: Array as () => Format[] }) value: Format[];

  banners: Format[] = [];
  options: Format[] = [];
  isLoading: boolean = false;

  input = InputValidation;
  formatService = FormatService;

  bindValue() {
    return this.value;
  }

  updateValue(value: Array<Format>) {
    this.$emit('input', value)
  }

  asyncFindBanners(query) {
    this.isLoading = true;
    this.options = this.banners.filter(c => c.displayTitle.toLowerCase().includes(query.toLowerCase()));
    this.isLoading = false;
  }

  created() {
    this.fetchFormats();
  }

  fetchFormats() {
    this.isLoading = true;
    this.formatService.getFormats().then(response => {
      if (response.status !== 200) {
        return [];
      }

      if (response && response.data) {
        this.banners = response.data.filter(x => x.formatType === FormatType.BANNER).sort(
          (a, b) => {
            if (a.displayTitle.toLowerCase() < b.displayTitle.toLowerCase()) {
              return -1;
            }
            if (a.displayTitle.toLowerCase() > b.displayTitle.toLowerCase()) {
              return 1;
            }
            return 0;
          });

        this.options = this.banners;
      }

      return [];
    });
    this.isLoading = false;
  }
}
